export default __webpack_public_path__ + "static/media/1.71c3c3b9.webp";